/** AIO平台路由 */
export const aioRoutes = {
  /** AIO登录 */
  AioLogin: '/aio/login',
  /** 权限创建 */
  AioPermissionCreate: '/aio/permission/create',
  /** 权限列表 */
  AioPermissionList: '/aio/permission/list',
  /** 营养成分 */
  AioNutrientList: '/aio/nutrient/list',
  /** 数据仓库 */
  AioDataWarehouseLits: '/aio/data_warehouse/list',
  /** 插件管理 */
  AioPluginList: '/aio/plugin/list',
  /** 下载管理 */
  AioDownloadInfoList: '/aio/download_info/list',
  /** 云商品库 */
  AioCloudProductList: '/aio/cloud_product/list',
  /** 日志管理 */
  AioFileList: '/aio/file/list',
};
